let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7QDxP")).then(() => parcelRequire('7D6Cd'));